import React from 'react';
import { Bookmark } from 'lucide-react';
import { Modal } from './ui/Modal';

const isMac = typeof navigator !== 'undefined' && /mac/i.test(navigator.platform);

interface SaveScenarioModalProps {
  isOpen: boolean;
  onClose: () => void;
}

export const SaveScenarioModal: React.FC<SaveScenarioModalProps> = ({ isOpen, onClose }) => {
  return (
    <Modal isOpen={isOpen} onClose={onClose}>
      <div className="flex flex-col items-center text-center gap-4 pt-2">
        <div className="flex items-center justify-center w-12 h-12 rounded-full bg-gold-100">
          <Bookmark className="text-gold-600" size={24} />
        </div>

        <div>
          <h3 className="text-lg font-semibold text-gray-900 mb-1">Bookmark this URL to Save</h3>
          <p className="text-sm text-gray-500">
            Press{' '}
            <kbd className="rounded bg-gray-100 border border-gray-300 px-1.5 py-0.5 font-mono text-xs">
              {isMac ? '⌘D' : 'Ctrl+D'}
            </kbd>{' '}
            to bookmark this page so you can return to it later.
          </p>
        </div>

        <div className="w-full pt-2">
          <button
            onClick={onClose}
            className="w-full px-4 py-2 text-sm font-medium text-navy-900 bg-gold-500 border border-transparent rounded-md hover:bg-gold-400 focus:outline-none focus:ring-2 focus:ring-gold-400 transition-colors"
          >
            OK
          </button>
        </div>
      </div>
    </Modal>
  );
};
